import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getCurrencySymbol, formatAmount } from '../utils/currency';

interface CurrencyState {
  currency: string;
  country: string;
  setCurrency: (code: string) => void;
  setCountry: (code: string) => void;
  /** Get the symbol for the current currency (€, $, ฿, etc.) */
  symbol: () => string;
  /** Format an amount with the current currency */
  formatPrice: (amount: number, locale?: string) => string;
}

export const useCurrencyStore = create<CurrencyState>()(
  persist(
    (set, get) => ({
      currency: 'EUR',
      country: 'DE',
      setCurrency: (code: string) => {
        set({ currency: code || 'EUR' });
      },
      setCountry: (code: string) => {
        set({ country: code || 'DE' });
      },
      symbol: () => getCurrencySymbol(get().currency),
      formatPrice: (amount: number, locale?: string) => {
        return formatAmount(amount, get().currency, locale || 'de-DE');
      },
    }),
    {
      name: 'bispicy-currency',
    }
  )
);
